export function getSortArray(sortArr, isSortModel, colId, isControlKey) {
  const prevSortArr = [...sortArr];
  if (isSortModel && isControlKey) {
    if (isSortModel && sortArr.every((obj) => obj.key !== colId)) {
      sortArr.push({
        key: colId,
        order: 1,
      });
    } else {
      if (isSortModel && sortArr.some((obj) => obj.key === colId)) {
        let tempArr = [...sortArr];
        tempArr = sortArr.filter((obj) => {
          if (obj.key !== colId || (obj.key === colId && obj.order === 1)) {
            return obj;
          }
        });
        sortArr = [...tempArr];
      }
      // eslint-disable-next-line no-unused-expressions
      sortArr.length > 0 &&
        isSortModel &&
        sortArr.forEach((obj) => {
          if (obj.key === colId) {
            obj.order = (obj.order + 1) % 2;
          }
        });
    }
  } else {
    if (isSortModel) {
      sortArr = sortArr.filter((obj) => {
        if (obj.key === colId) {
          obj.order = (obj.order + 1) % 2;
          return obj;
        }
      });

      if (isSortModel && sortArr.every((obj) => obj.key !== colId)) {
        sortArr = [
          {
            key: colId,
            order: 1,
          },
        ];
      }
    }
  }
  if (sortArr.length === 0) {
    sortArr = [...prevSortArr];
    sortArr.forEach((obj) => {
      if (obj.key === colId) {
        obj.order = (obj.order + 1) % 2;
      }
    });
  }
  return sortArr;
}

export default {
  getSortArray,
};
